import ClaimsFlowPictogram from 'app/assets/Pictograms/ClaimsFlow.svg';
import MedicalClaimsFlowPictogram from 'app/assets/Pictograms/MedicalClaimsFlow.svg';
import ClaimsEmailFlowPictogram from 'app/assets/Pictograms/ClaimsEmailFlow.svg';
import CatastropheDetectionPictogram from 'app/assets/Pictograms/CatastropheDetectionFlow.svg';
import DocumentComparePictogram from 'app/assets/Pictograms/DocumentCompareFlow.svg';
import LegalFlowPictogram from 'app/assets/Pictograms/LegalFlow.svg';
import MedicalClaimsExampleImage from 'app/assets/Other/MedicalClaimsPDFSummaryExample.png';
import ClaimsExampleImage from 'app/assets/Other/ClaimsInsightsExample.png';
import LegalExampleImage from 'app/assets/Other/ContractInsightsExample.png';
import ClaimsEmailExampleImage from 'app/assets/Other/ClaimsEmailSummaryExample.png';
import FNOLCapturingFlowPictogram from 'app/assets/Pictograms/FNOLCapturingFlow.svg';
import FNOLCapturingExampleImage from 'app/assets/Other/FNOLCapturingPDFSummaryExample.png';
import IDExtractionProPictogram from 'app/assets/Pictograms/IDExtractionProFlow.svg';
import IDExtractionProImage from 'app/assets/Other/IDExtractProExample.png';
import CallSummaryPictogram from 'app/assets/Pictograms/CallSummaryFlow.svg';
import CallSummaryImage from 'app/assets/Other/CallSummaryExample.png';
import CatiaExampleImage from 'app/assets/Other/CatiaExample.png';
import DocumentCompareExampleImage from 'app/assets/Other/DocumentCompareExample.png';
import DocumentCompareV2ExampleImage from 'app/assets/Other/DocumentCompareV2Example.png';
import TranslatorImage from 'app/assets/Other/TranslatorExample.png';
import TranslatorFlow from 'app/assets/Pictograms/TranslatorFlow.svg';
import ContractSummarizerPictogram from 'app/assets/Pictograms/ContractSummarizerFlow.svg';
import ContractSummarizerImage from 'app/assets/Other/ContractSummarizerExample.png';
import InvoiceExtractorExampleImage from 'app/assets/Other/InvoiceIQExample.png';
import InvoiceExtractorFlowPictogram from 'app/assets/Pictograms/InvoiceExtractorFlow.svg';
import CoverageCheckExampleImage from 'app/assets/Other/CoverageCheckExample.png';
import CoverageCheckFlowPictogram from 'app/assets/Pictograms/CoverageCheckFlow.svg';
import PostCallAnalysisPictogram from 'app/assets/Pictograms/RetentionCallAnalysisPictogram.svg';
import PostCallAnalysisExampleImage from 'app/assets/Other/PostCallAnalysisExampleImage.png';
import IgprScoreFlowPictogram from 'app/assets/Pictograms/IgprScoreFlow.svg';
import CoverageCheckV2Pictogram from 'app/assets/Pictograms/CoverageCheckV2Pictogram.svg';
import AssuraceReportDraftingFlowPictogram from 'app/assets/Pictograms/AssuraceReportDraftingFlow.svg';
import AssuraceReportDraftingExampleImage from 'app/assets/Other/AssuranceReportDraftingExample.png';
import AskYourDocsFlowPictogram from 'app/assets/Pictograms/AskYourDocsFlowPictogram.svg';
import TypeOfLossFlowPictogram from 'app/assets/Pictograms/TypeOfLossPictogram.svg';
import TypeOfLossExampleImage from 'app/assets/Other/TypeOfLossExampleImage.png';

import { IServicesData } from './types';

export const ServicesData: IServicesData = {
  'claims-insights': {
    API: 'https://ai-genai-bizservices-we-dev-app-001.azurewebsites.net/api/claims-insights/docs',
    SummaryTitle: 'Claims insights',
    FlowImage: ClaimsFlowPictogram,
    FlowHeading: 'Claims insights',
    FlowInput: 'Loss Adjustor Reports',
    FlowTask:
      'Extract structured information, provide summaries and translations, classification of perils and distinguish between business interruption and property damage.',
    FlowOutput:
      'Structured information from the claim report (e.g. Type of Loss, Rootcause and Narrative of the incident)',
    ExampleImage: ClaimsExampleImage,
    ExampleHeading: 'Claims insights sample',
    ExtractionType: 'extraction'
  },
  'medical-claims-summary': {
    API: 'https://ai-genai-bizservices-we-dev-app-001.azurewebsites.net/api/medical-claims-summary/docs',
    SummaryTitle: 'Medical claim summary',
    FlowImage: MedicalClaimsFlowPictogram,
    FlowHeading: 'Medical claim summary',
    FlowInput: 'Claim related medical document',
    FlowTask:
      'Summarize the document focusing on medical concepts such as diagnosis and symptoms',
    FlowOutput: 'Summary of the medical document',
    ExampleImage: MedicalClaimsExampleImage,
    ExampleHeading: 'Medical claim summary sample',
    ExtractionType: 'summary'
  },
  'contract-insights': {
    API: 'https://ai-genai-bizservices-we-dev-app-001.azurewebsites.net/api/contract-insights/docs',
    SummaryTitle: 'Contract insights',
    FlowImage: LegalFlowPictogram,
    FlowHeading: 'Contract insights',
    FlowInput: 'Legal contract',
    FlowTask:
      'Extract structured information, summarizing the purpose and obligations, and simplifying language, catering to the needs of Zurich Insurance',
    FlowOutput:
      'Structured information from contract (e.g. Parties, Term, Jurisdiction, others)',
    ExampleImage: LegalExampleImage,
    ExampleHeading: 'Contract insights sample',
    ExtractionType: 'extraction'
  },
  'claims-email-summary': {
    API: 'https://ai-genai-bizservices-we-dev-app-001.azurewebsites.net/api/claims-email-summary/docs',
    SummaryTitle: 'Claims email summary',
    FlowImage: ClaimsEmailFlowPictogram,
    FlowHeading: 'Claims email summary',
    FlowInput: 'Email conversation',
    FlowTask:
      'Summarization of complex email conversations filtering out the noise such as disclaimers, headers/footers, and signatures',
    FlowOutput:
      'Short summary of an email provided in the language of the email',
    ExampleImage: ClaimsEmailExampleImage,
    ExampleHeading: 'Claims email summary sample',
    ExtractionType: 'email-summary'
  },
  'fnol-capturing': {
    API: 'https://ai-genai-bizservices-we-dev-app-001.azurewebsites.net/api/fnol-capturing/docs',
    SummaryTitle: 'FNOL capturing',
    FlowImage: FNOLCapturingFlowPictogram,
    FlowHeading: 'FNOL capturing',
    FlowInput: 'FNOL call',
    FlowTask:
      'Extract structured information, simplify the language and summarize',
    FlowOutput:
      'Structured FNOL report (e.g. Policyholder information, date & time of loss, description of loss, others)',
    ExampleImage: FNOLCapturingExampleImage,
    ExampleHeading: 'FNOL capturing sample',
    ExtractionType: 'extraction'
  },
  'id-extract-pro': {
    API: 'https://ai-genai-bizservices-we-dev-app-001.azurewebsites.net/api/cross-functional/id-extract-pro/docs',
    SummaryTitle: 'IDExtract Pro',
    FlowImage: IDExtractionProPictogram,
    FlowHeading: 'IDExtract Pro',
    FlowInput: 'ID document',
    FlowTask: 'Extract structured information',
    FlowOutput:
      'ID file fields (e.g. Name, Surnames, ID number, Date of Birth, Nationality, Expedition Date and others)',
    ExampleImage: IDExtractionProImage,
    ExampleHeading: 'IDExtract Pro sample',
    ExtractionType: 'extraction'
  },
  'call-summary': {
    API: 'https://ai-genai-bizservices-we-dev-app-001.azurewebsites.net/api/cross-functional/call-summary/docs',
    SummaryTitle: 'Call summary',
    FlowImage: CallSummaryPictogram,
    FlowHeading: 'Call summary',
    FlowInput: 'Call between a call center agent and caller',
    FlowTask:
      'Extract and summarize structured call information, translate to one of the 5 pre-defined languages',
    FlowOutput:
      'Structured call summary report (e.g. brief and clear summary, key customer information, issue description, others)',
    ExampleImage: CallSummaryImage,
    ExampleHeading: 'Call summary sample',
    ExtractionType: 'extraction'
  },
  translator: {
    API: 'https://ai-genai-bizservices-we-dev-app-001.azurewebsites.net/api/cross-functional/transtalor/docs',
    SummaryTitle: 'TranslatAI',
    FlowImage: TranslatorFlow,
    FlowHeading: 'TranslatAI',
    FlowInput: 'Input in any of our 30 supported languages.',
    FlowTask:
      'Translate the provided input into one of our collection of over 30 languages',
    FlowOutput: 'Translation result',
    ExampleImage: TranslatorImage,
    ExampleHeading: 'TranslatAI sample',
    ExtractionType: 'translation'
  },
  'invoice-extractor': {
    API: 'https://ai-genai-bizservices-we-dev-app-001.azurewebsites.net/api/cross-functional/invoice-extractor/docs',
    SummaryTitle: 'InvoiceIQ',
    FlowImage: InvoiceExtractorFlowPictogram,
    FlowHeading: 'InvoiceIQ',
    FlowInput: 'Invoice Document',
    FlowTask: 'Extract structured information',
    FlowOutput:
      'Invoice file fields (e.g. Amount Due, Billing Address, Customer Name, Vendor Name, Due Date, Items and others)',
    ExampleImage: InvoiceExtractorExampleImage,
    ExampleHeading: 'InvoiceIQ sample',
    ExtractionType: 'extraction'
  },
  'contract-summarizer': {
    API: 'https://ai-genai-bizservices-we-dev-app-001.azurewebsites.net/api/cross-functional/contract-summarizer/docs',
    SummaryTitle: 'Contract summarizer',
    FlowImage: ContractSummarizerPictogram,
    FlowHeading: 'Contract summarizer',
    FlowInput: 'Contract file',
    FlowTask: 'Summarize the provided contract and display the results',
    FlowOutput: 'Summarized fields of the contract',
    ExampleImage: ContractSummarizerImage,
    ExampleHeading: 'Contract summarizer sample',
    ExtractionType: 'extraction'
  },
  'nda-generator': {
    API: 'https://ai-genai-bizservices-we-dev-app-001.azurewebsites.net/api/legals/nda-generator/docs',
    SummaryTitle: 'NDA Generator',
    FlowImage: LegalFlowPictogram,
    FlowHeading: 'NDA Generator',
    FlowInput: 'NDA parameters (parties, purpose, duration, etc.)',
    FlowTask:
      'Generate a customized Non-Disclosure Agreement based on provided parameters and templates',
    FlowOutput: 'Complete NDA document ready for review and signing',
    ExampleImage: LegalExampleImage,
    ExampleHeading: 'NDA Generator sample',
    ExtractionType: 'generation'
  },
  'coverage-check': {
    API: 'https://ai-genai-bizservices-we-dev-app-001.azurewebsites.net/api/cross-functional/coverage-check/docs',
    SummaryTitle: 'Coverage check',
    FlowImage: CoverageCheckFlowPictogram,
    FlowHeading: 'Coverage check',
    FlowInput:
      'FNOL transcript or a brief loss description, insurance policy file, and optionally invoice file.',
    FlowTask:
      'Checks if items listed in the FNOL are covered by the policy and verifies invoice items against policy terms.',
    FlowOutput:
      'Coverage analysis based on the reported losses, insurance policy and relevant invoices (if provided)',
    ExampleImage: CoverageCheckExampleImage,
    ExampleHeading: 'Coverage check sample',
    ExtractionType: 'extraction'
  },
  'retention-call': {
    API: 'https://ai-genai-bizservices-we-dev-app-001.azurewebsites.net/api/cross-functional/retention-calls/docs',
    SummaryTitle: 'Post-call analysis',
    FlowImage: PostCallAnalysisPictogram,
    FlowHeading: 'Post-call analysis',
    FlowInput: 'Mp3 call file',
    FlowTask: 'Extract and summarize structured call information',
    FlowOutput: 'Structured call information',
    ExampleImage: PostCallAnalysisExampleImage,
    ExampleHeading: 'Post-call analysis sample',
    ExtractionType: 'extraction'
  },
  'catastrophe-detection': {
    API: 'https://ai-genai-bizservices-we-dev-app-001.azurewebsites.net/api/claims/catia/docs',
    SummaryTitle: 'CATIA',
    FlowImage: CatastropheDetectionPictogram,
    FlowHeading: 'CATIA',
    FlowInput: 'CSV-like claims over API',
    FlowTask:
      'Based on certain criterias performs analysis of possible catastrophe',
    FlowOutput: 'Structured call information',
    ExampleImage: CatiaExampleImage,
    ExampleHeading: 'Analysis sample',
    ExtractionType: 'extraction'
  },
  'document-compare': {
    API: '', // API removed - using local comparison only
    SummaryTitle: 'Document compare (Local)',
    FlowImage: DocumentComparePictogram,
    FlowHeading: 'Document compare (Local)',
    FlowInput: 'Two documents in .pdf format',
    FlowTask: 'Checks differences between two provided documents',
    FlowOutput: 'Structure compare or text-based only compare',
    ExampleImage: DocumentCompareExampleImage,
    ExampleHeading: 'Document compare sample',
    ExtractionType: 'extraction'
  },
  'igpr-score': {
    API: 'https://ai-genai-bizservices-we-dev-app-001.azurewebsites.net/api/docs/igpr-score/docs',
    SummaryTitle: 'iGPR Score',
    FlowImage: IgprScoreFlowPictogram,
    FlowHeading: 'iGPR Score',
    FlowInput: 'iGPR Score over API',
    FlowTask:
      'Based on certain criterias performs analysis of possible catastrophe',
    FlowOutput: 'Structured call information',
    ExampleHeading: 'iGPR Score',
    ExtractionType: 'igpr'
  },
  'coverage-check-v2': {
    API: 'https://ai-genai-bizservices-we-dev-app-001.azurewebsites.net/api/v2/claims/coverage-check/docs',
    SummaryTitle: 'Coverage check',
    FlowImage: CoverageCheckV2Pictogram,
    FlowHeading: 'Coverage Check',
    FlowInput:
      'Documents: claims notification, terms and conditions, and policy contract. If necessary, extra documents such as invoices and quotes could also be included.',
    FlowTask:
      'Analyse the documents and arrive at a coverage status (covered, not covered, or inconclusive), get a justification, and extract details from the provided documents.',
    FlowOutput:
      'Coverage status, a justification, and details extracted from the provided documents.',
    ExampleHeading: '',
    ExtractionType: 'extraction'
  },
  'assurance-report-drafting': {
    API: 'https://ai-genai-bizservices-we-dev-app-001.azurewebsites.net/api/compliance/assurance-report-drafting/docs',
    SummaryTitle: 'Assurance report drafting',
    FlowImage: AssuraceReportDraftingFlowPictogram,
    FlowHeading: 'Assurance report drafting',
    FlowInput: 'Terms of Reference (ToR) document.',
    FlowTask:
      'Generate a draft assurance report based on the uploaded Terms of Reference (ToR) document.',
    FlowOutput: 'Draft assurance report file.',
    ExampleImage: AssuraceReportDraftingExampleImage,
    ExampleHeading: 'Assurance report drafting sample',
    ExtractionType: 'extraction'
  },
  'ask-your-docs': {
    API: 'https://ai-genai-bizservices-we-dev-app-001.azurewebsites.net/api/cross-functional/ask-your-docs/docs',
    SummaryTitle: 'Assurance report drafting',
    FlowImage: AskYourDocsFlowPictogram,
    FlowHeading: 'Ask Your Docs',
    FlowInput: 'Document files and natural language questions',
    FlowTask:
      'Analyze documents and provide intelligent answers to user questions',
    FlowOutput: 'Contextual answers extracted from the uploaded documents',
    ExampleHeading: 'Assurance Your Docs sample',
    ExtractionType: 'extraction'
  },
  'document-compare-v2': {
    API: 'https://ai-genai-bizservices-we-dev-app-001.azurewebsites.net/api/v2/cross-functional/document-compare/docs',
    SummaryTitle: 'DocuCompare',
    FlowImage: DocumentComparePictogram,
    FlowHeading: 'DocuCompare',
    FlowInput: 'Two documents in .pdf format',
    FlowTask: 'Checks differences between two provided documents',
    FlowOutput: 'Structured comparison',
    ExampleImage: DocumentCompareV2ExampleImage,
    ExampleHeading: 'DocuCompare sample',
    ExtractionType: 'extraction'
  },
  'type-of-loss': {
    API: 'https://ai-genai-bizservices-we-dev-app-001.azurewebsites.net/api/claims/type-of-loss/docs',
    SummaryTitle: 'Loss Classifier',
    FlowImage: TypeOfLossFlowPictogram,
    FlowHeading: 'Loss Classifier',
    FlowInput: 'One required claims file and one optional training data file',
    FlowTask: 'Predicts the type of loss for each claim',
    FlowOutput: 'Excel file with claims and their predicted types of loss',
    ExampleImage: TypeOfLossExampleImage,
    ExampleHeading: 'Loss Classifier sample',
    ExtractionType: 'extraction'
  }
};

export const MaturityDescriptions: { [key: string]: string } = {
  Low: "Discover the potential of <service> in this exploratory stage. It's an illustrative showcase that highlights the concept and possibilities of what this service can offer.",
  Medium:
    'Join us in the testing stage of <service>, where business users put the service through its paces. We actively gather feedback, iron out any issues, and make improvements based on user testing results.',
  High: '<service> is now fully operational. It has been tested and approved for business needs, ready to streamline operations and deliver the intended functionalities and features. Experience the value it brings to your business.'
};

export const HighlightsFeatureTooltipContent =
  'Discover the power of our highlighting feature by simply clicking on the title of extracted parameters. Stay tuned as we continue to expand this feature, bringing even more functionalities to enhance your user journey.';

export const ContractSummarizerTypeSelectorTooltip =
  'Use this selector to switch between different summarization algorithms.';

export const SpeechFeaturesTooltipContent = `We're currently working on adding audio processing capabilities to enhance your translation experience. Stay tuned for future releases where this feature will be available.`;

export const FileTranslationFeaturesTooltipContent = `We're currently working on adding file translation features to our service. Stay tuned for future releases where this feature will be available.`;

export const EstimatedCostKpiInfoTooltipContent = `The estimated cost calculations are based on data starting from May 2024. Please note that not all services may have an associated cost.`;
export const SavedTimeKpiInfoTooltipContent = `Please note that the calculation of saved time is an estimation based from the average time it takes an individual to process a specific amount of data.`;
export const SavedMoneyKpiInfoTooltipContent = `Please note that the calculation of money saved is an estimation derived from the estimated saved time and the average cost of an employee.`;

export const SERVICE_NAMES = {
  CALL_SUMMARY: 'call-summary',
  CLAIMS_INSIGHTS: 'claims-insights',
  MEDICAL_CLAIMS_SUMMARY: 'medical-claims-summary',
  CONTRACT_INSIGHTS: 'contract-insights',
  CLAIMS_EMAIL_SUMMARY: 'claims-email-summary',
  DOCUMENT_COMPARE: 'document-compare',
  FNOL_CAPTURING: 'fnol-capturing',
  ID_EXTRACT_PRO: 'id-extract-pro',
  TRANSLATOR: 'translator',
  INVOICE_EXTRACTOR: 'invoice-extractor',
  CONTRACT_SUMMARIZER: 'contract-summarizer',
  COVERAGE_CHECK: 'coverage-check',
  RETENTION_CALL: 'retention-call',
  CATASTROPHE_DETECTION: 'catastrophe-detection',
  IGPR_SCORE: 'igpr-score',
  COVERAGE_CHECK_V2: 'coverage-check-v2',
  ASSURANCE_REPORT_DRAFTING: 'assurance-report-drafting',
  ASK_YOUR_DOCS: 'ask-your-docs',
  NDA_GENERATOR: 'nda-generator',
  DOCUMENT_COMPARE_V2: 'document-compare-v2',
  TYPE_OF_LOSS: 'type-of-loss',
  DOC_GENERATOR: 'doc-generator'
};

export const COVERAGE_CHECK_STEPS = {
  FNOL: 'first-notice-of-loss',
  POLICY: 'policy-coverage',
  INVOICE: 'invoice-coverage'
};

export const noSummaryExtractionServices = [
  SERVICE_NAMES.TRANSLATOR,
  SERVICE_NAMES.COVERAGE_CHECK,
  SERVICE_NAMES.RETENTION_CALL,
  SERVICE_NAMES.CATASTROPHE_DETECTION,
  SERVICE_NAMES.DOCUMENT_COMPARE,
  SERVICE_NAMES.ASSURANCE_REPORT_DRAFTING,
  SERVICE_NAMES.NDA_GENERATOR,
  SERVICE_NAMES.DOCUMENT_COMPARE_V2,
  SERVICE_NAMES.ASSURANCE_REPORT_DRAFTING,
  SERVICE_NAMES.TYPE_OF_LOSS
];

export const noRenderUploadFileButton = [
  SERVICE_NAMES.CLAIMS_EMAIL_SUMMARY,
  SERVICE_NAMES.CALL_SUMMARY,
  SERVICE_NAMES.TRANSLATOR,
  SERVICE_NAMES.COVERAGE_CHECK,
  SERVICE_NAMES.RETENTION_CALL,
  SERVICE_NAMES.CATASTROPHE_DETECTION,
  SERVICE_NAMES.DOCUMENT_COMPARE,
  SERVICE_NAMES.DOCUMENT_COMPARE_V2,
  SERVICE_NAMES.IGPR_SCORE,
  SERVICE_NAMES.COVERAGE_CHECK_V2,
  SERVICE_NAMES.ASK_YOUR_DOCS,
  SERVICE_NAMES.ASSURANCE_REPORT_DRAFTING,
  SERVICE_NAMES.NDA_GENERATOR,
  SERVICE_NAMES.TYPE_OF_LOSS
];

export const UNDEFINED_FILES = {
  claims: undefined,
  policy: undefined,
  terms: undefined,
  extra: undefined
};
